import { CopyIconItemProps } from '@raisin/components-lib';

export const checkAllItemsHasIcon = (items: CopyIconItemProps[]) =>
  items.length !== 0 && items.every((item) => item.icon && item.icon.length !== 0);
